import React, { useEffect } from 'react';
import { URLS } from '../../_config';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useToken } from '../../_common/hooks/authHook';
import { APP_NAME, LOGO_URL } from '../../_config/site_urls';
import ThankYouFooter from '../../components/layouts/ThankYouFooter';

const ThankYou: React.FC = () => {
    let tokenData: any = useToken('thank-you');
    const location = useLocation();
    const navigate = useNavigate();
    const fromSubmission = location.state?.fromSubmission === true;

    useEffect(() => {
        if (!fromSubmission) {
            navigate(URLS.HOME, { replace: true });
        }
    }, []);

    if (!fromSubmission) return null;

    return (
        <div className="thank-you-page">
            <div className="home-icon"><Link to={URLS.HOME}><i className='bx bx-home'></i></Link>
            </div>
            <div>
                <Link to={URLS.HOME}><img className="nav-logo" src={LOGO_URL} alt={APP_NAME} /></Link>
            </div>
            <div className="thank-you-text">
                <img src="/images/img/thank-you-img.png" alt='Thank You' className='float-left' />
                <h1>Service  <span>Request  <b>Submitted!</b></span></h1>
                <p>Thank you for submitting your service request. </p>
                <p>Our team is working on it, and we will notify you via email as soon as it's ready.</p>
                <p>In the meantime, you can log in to your account to check the status of your service request at any time. </p>
                <span data-aos="zoom-in" className="aos-init aos-animate">
                    <Link to={(tokenData) ? URLS.ACCOUNT.MY_BUSINESS_PLAN : URLS.LOGIN} target="_blank" rel="noopener noreferrer">
                        <button type="button" className="master-orng-btn xl-orng-btn">{(tokenData) ? "My business services" : "Log In to Your Account"}</button>
                    </Link>
                </span>
            </div>

            <ThankYouFooter />
        </div>
    );
};

export default ThankYou;
